import { render, staticRenderFns } from "./AsociarMensajesFormDetalle.vue?vue&type=template&id=ab2a86c4&scoped=true&"
import script from "./AsociarMensajesFormDetalle.vue?vue&type=script&lang=ts&"
export * from "./AsociarMensajesFormDetalle.vue?vue&type=script&lang=ts&"
import style0 from "./AsociarMensajesFormDetalle.vue?vue&type=style&index=0&id=ab2a86c4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab2a86c4",
  null
  
)

export default component.exports